const tenantCustonConfig = {
  brandName: "Payscan",
  currencies: [{ value: "152", label: "Peso Chileno", code: "CLP", symbol: "$" }],
  disabledCreateNewSellerUser: true,
  dropdownMenuItems: ["config","bankAccount"],
  helpModal: {
    frequentQuestionsURL: "#COMPLETAR_URL",
    contactFormURL:"#COMPLETAR_URL",
    contactEmail:"#COMPLETAR_EMAIL"
  },
  automaticCashout: {
    isEnabled: false
  },
  ecommerceStore: {
    documentRegexValidation: /^[\w\W]+$/,
    documentRequired: 1
  },
  paramNameSubsidiaryId: 'subsidiaryId',
  termsAndConditions: false,
  activatePoket: false,
  sales: {
    showFilterSubsidiariesWidget: true,
    transactionReceipt: {
      summary: [
        // {
        //   label: "Titular de tarjeta",
        //   method: (sale) => sale.payment.cardHolderName,
        // },
        {
          label: "Terminal ID",
          method: (sale) => sale.terminalID,
        },
        {
          label: "Nº de autorización",
          method: (sale) => sale.authorizationCode,
        },
        {
          label: 'Origen',
          method: sale => sale.origin,
        },
      ],
      contactData: [
        {
          label: "name",
          method: (sale) => false
        },
        {
          label: "email",
          method: (sale) => false,
        },
        {
          label: "phone",
          method: (sale) => false,
        },
      ],
    },
  },
  stats: {
    statsEnabled: ["products", "staff"],
    startDateDaysSubtracted: 7
  },
  currencyDecimals:true,
  bankAccountNumberLabel: "Cuenta Bancaria",
  tenantMaxLength: {
    phoneLength: 12,
    documentLength: 10,
  },
  charts : {
    colors : ["#00055B", "#66699D", "#999BBD", "#B3B4CE", "#CCCDDE", "#E6E6EF"],
    sales: {
      colors: ["#00055B", "#00F9D3"]
    }
  },
  showMaxMonthlyAmount: false
};

const tenantTableColumns = {};

export {
  tenantCustonConfig,
  tenantTableColumns,
}

